import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN || 'localhost:3000',
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Configure Firebase Auth for HTTPS support
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Enable HTTPS-only settings for production
if (process.env.NODE_ENV === 'production') {
  auth.settings.appVerificationDisabledForTesting = false;
}

export { auth, app };
export const db = getFirestore(app);
export const storage = getStorage(app);
